export class CustomerAuthentication {
  constructor({ ID = 0, type = 0, number = null } = {}) {
    this.ID = ID;
    this.type = type;
    this.number = number;
  }
}

export function createCustomerAuthentication(data) {
  return Object.freeze(new CustomerAuthentication(data));
}
